import { render, staticRenderFns } from "./rating-quarternary.vue?vue&type=template&id=6c19eeb4&scoped=true"
import script from "./rating-quarternary.vue?vue&type=script&lang=js"
export * from "./rating-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19eeb4",
  null
  
)

export default component.exports